import { createTheme } from '@material-ui/core/styles';
import { theme, cnTheme } from '../../../../styles/theme';
import { getDomain } from '../../../../utils/config';

const mainTheme = getDomain() === 'onsemi.com' ? theme : cnTheme;

const designTableTheme = createTheme({
	...mainTheme,
	overrides: {
		...mainTheme.overrides,
		MuiToolbar: {
			root: {
				padding: '0 !important'
			}
		},
		MuiFormControl: {
			root: {
				width: '100%',
				maxWidth: 250
			}
		},
		MuiInput: {
			underline: {
				'&:after': {
					borderBottomColor: mainTheme.palette.secondary.main
				}
			},
			input: {
				fontSize: mainTheme.typography.body1.fotnSize
			}
		},
		MuiTableRow: {
			root: {
				'&:not(:only-child)': {
					height: 70
				},
				'&:last-child:only-child td': {
					borderBottom: 0
				},
				'&$selected, &$selected:hover': {
					backgroundColor: 'rgba(0, 0, 0, 0.04)'
				}
			},
			head: {
				height: 'auto'
			}
		},
		MuiTableCell: {
			body: {
				padding: '4px 8px',
				fontSize: mainTheme.typography.body2.fotnSize
			},
			head: {
				padding: '8px',
				fontSize: mainTheme.typography.body2.fontSize,
				lineHeight: 1.4
			}
		},
		MuiSelect: {
			root: {
				fontSize: mainTheme.typography.body1.fotnSize
			}
		},
		MuiCircularProgress: {
			circle: {
				color: mainTheme.palette.primary.main
			}
		},
		MuiIconButton: {
			root: {
				color: `${mainTheme.palette.text.secondary} !important`
			}
		}
	}
});

export default designTableTheme;
